// components/ErrorButtons.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/ErrorButtons.css';

export const ErrorButtons = () => {
  const navigate = useNavigate();

  return (
    <div className="error-buttons">
      <button
        onClick={() => navigate('/')}
        className="error-button error-button-primary"
      >
        Return Home
      </button>
      <button
        onClick={() => window.location.reload()}
        className="error-button error-button-secondary"
      >
        Try Again
      </button>
    </div>
  );
};